import { ajax } from '@/util/ajax'

const BASE_URL = '/gateway/platform-openapi/auth'

const AuthApi = {
  signIn (account, password, grantType, systemName, success, failure) {
    return ajax.post(
      BASE_URL + '/sign-in',
      {
        account: account,
        password: password,
        grantType: grantType,
        systemName: systemName
      },
      success,
      failure,
      { couldCancel: false }
    )
  },

  signOut (formData, success, failure) {
    return ajax.post(
      BASE_URL + '/sign-out',
      formData,
      success,
      failure,
      { couldCancel: false }
    )
  },

  getAccount (token, success, failure) {
    return ajax.get(BASE_URL + '/get-account', { token: token }, success, failure, { couldCancel: false })
  },

  getAuthorization (token, success, failure) {
    return ajax.get(BASE_URL + '/get-authorization', { token: token }, success, failure, { couldCancel: false })
  },

  changePassword (data, success, failure) {
    return ajax.post(
      BASE_URL + '/change-account-password?oldPassword={0}&newPassword={1}&email={2}&token={3}'.format(data.oldPassword,
        data.newPassword,
        data.email,
        data.token),
      null, success, failure,
      { couldCancel: false })
  },

  sendCaptcha (data, success, failure) {
    return ajax.post(BASE_URL + '/send-captcha?email={0}'.format(data.email), null, success, failure, { couldCancel: false })
  },

  resetPassword (data, success, failure) {
    return ajax.post(BASE_URL + '/reset-account-password?password={0}&captcha={1}&email={2}'.format(data.password, data.captcha, data.email),
      null, success, failure, { couldCancel: false })
  },

  online (data, success, failure) {
    return ajax.post(BASE_URL + '/online', null, success, failure, { couldCancel: false })
  },

  token (data, success, failure) {
    return ajax.post(BASE_URL + '/token', null, success, failure, { couldCancel: false })
  },

  verifyCaptcha (data, success, failure) {
    return ajax.post(BASE_URL + '/verify-one-time-passcode?captcha={0}&email={1}'.format(data.captcha, data.email),
      null, success, failure, { couldCancel: false })
  },

  resendCaptcha (data, success, failure) {
    return ajax.post(BASE_URL + '/resend-otp?email={0}'.format(data.email),
      null, success, failure, { couldCancel: false })
  }
}

export { AuthApi }
